import { enableProdMode } from '@angular/core';
import { environment } from './environments/environment';
import * as __NgCli_bootstrap_1 from "./app/app.module.ngfactory";
import * as __NgCli_bootstrap_2 from "@angular/platform-browser";
// See also AutoRefreshMode in index.ejs
window.sessionStorage.setItem('ApplicationIsLoaded', 'true');
// Support for drag-and-drop for mobile dropped, see: #2878
// import '../node_modules/drag-drop-touch/DragDropTouch';
if (environment.production) {
    enableProdMode();
}
// Communicate that Angular is started
if (window['angularStarted']) {
    window['angularStarted']();
}
// Tell the user the application is starting
if (window['bootProgress']) {
    window['bootProgress']('Starting the application', 20);
}
// Only bootstrap the app if we are not in an iframe (Fix for 'waiting for OpenId' #2928)
if (window === window.parent) {
    __NgCli_bootstrap_2.platformBrowser().bootstrapModuleFactory(__NgCli_bootstrap_1.AppModuleNgFactory);
}
else {
    // Callback for silence refresh of tokens
    parent.postMessage(location.hash, location.origin);
    console.warn('Application is in an iframe (for token refresh) and therefore no bootstrap is needed.');
    if (window['bootProgress']) {
        window['bootProgress']('Application not started', 100);
    }
}
